import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../Components/Loader";
import "./style.css";
import LoginForm from "../../Components/Forms/LoginForm";
import Footer from "../../Layout/Footer";

// assets
import AnimationSection from "../../Components/AnimationSection";

const Login = () => {
  const [data, setData] = useState();
  useEffect(async () => {
    const home = await axios.get(
      "https://staging-cms-main.ipurvey.com/homepage"
    );
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData([home.data, layout.data]);
  }, []);
  if (data) {
    return (
      <>
        <div className="user_acc_container">
          <div className="user_acc_md">
            <div className="user_acc_left_md">
              <AnimationSection
                data={data[0]}
                forms={<LoginForm data={data[1]} />}
              />
            </div>
          </div>
        </div>
        <Footer data={data[1]} />
      </>
    );
  } else {
    return <Loader />;
  }
};

export default Login;
